import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAeExportSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAeExportSettingsQuery = { __typename?: 'Query', getAeExportSettings?: { __typename?: 'AeExportSettings', assetFolderId?: string | null, assetFolderName?: string | null, exportMarkersAsCommentsEnabled?: boolean | null, localCopyEnabled?: boolean | null, localFolderPath?: string | null, outputModuleTemplate?: string | null, range?: Types.AeExportRange | null, renderSettingTemplate?: string | null } | null };


export const GetAeExportSettings = /*#__PURE__*/ gql`
    query GetAeExportSettings {
  getAeExportSettings {
    assetFolderId
    assetFolderName
    exportMarkersAsCommentsEnabled
    localCopyEnabled
    localFolderPath
    outputModuleTemplate
    range
    renderSettingTemplate
  }
}
    ` as unknown as DocumentNode<GetAeExportSettingsQuery, GetAeExportSettingsQueryVariables>;

          

          export const useGetAeExportSettingsQuery = (options?:QueryHookOptions<GetAeExportSettingsQuery, GetAeExportSettingsQueryVariables>) => useQuery(GetAeExportSettings, options);

          

          export type GetAeExportSettingsQueryOptions = QueryHookOptions<GetAeExportSettingsQuery, GetAeExportSettingsQueryVariables>;

          

          export const useGetAeExportSettingsLazyQuery = (options?:LazyQueryHookOptions<GetAeExportSettingsQuery, GetAeExportSettingsQueryVariables>) => useLazyQuery(GetAeExportSettings, options);

          

          export type GetAeExportSettingsQueryResult = ReturnType<typeof useGetAeExportSettingsQuery>;

          
